import { __rest } from "tslib";
import React from 'react';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import LargeSophisticatedTooltipHeading from '../LargeSophisticatedTooltipHeading';
import SophisticatedTooltipText from '../SophisticatedTooltipText';
import s from './LargeSophisticatedTooltipContent.scss';
/**
 * Lays out the content for our large sophisticated tooltips.
 *
 * Either `heading` or `aria-label` is required so a11y software will know what the tooltip is for.
 */
var LargeSophisticatedTooltipContent = function (_a) {
    var description = _a.description, prefix = _a.prefix, postfix = _a.postfix, labelOrHeading = __rest(_a, ["description", "prefix", "postfix"]);
    // We won't always use this because we also accept `aria-label` in place of `heading` for a11y.
    var headingId = useUniqueId();
    var heading = labelOrHeading.heading;
    var ariaLabel = labelOrHeading['aria-label'];
    return (React.createElement("div", { className: s['root'], role: "dialog", "aria-labelledby": heading ? headingId : undefined, "aria-label": ariaLabel ? ariaLabel : undefined },
        prefix && React.createElement("div", { className: s['prefix'] }, prefix),
        React.createElement("div", { className: s['text-block'] },
            heading && (React.createElement(LargeSophisticatedTooltipHeading, { id: headingId }, heading)),
            description && (React.createElement(SophisticatedTooltipText, null, description)),
            postfix)));
};
LargeSophisticatedTooltipContent.displayName =
    'LargeSophisticatedTooltipContent';
export default LargeSophisticatedTooltipContent;
//# sourceMappingURL=LargeSophisticatedTooltipContent.js.map